"use client";
import ForgotPassword from '@/components/Account/ForgotPassword/ForgotPassword';
import React from 'react'
const page = () => {
    return (
        <ForgotPassword />
    )
}

export default page